module.exports = __webpack_public_path__ + "static/philoso-5e6b0971fe34a8a8a8e1988d84a72816.svg";